import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import ProductGallery from "./ProductGalary/ProductGalary";
import ProductText from "./ProductText/ProductText";
import { useDispatch, useSelector } from "react-redux";
import { getCarByIdAction } from "../../redux/actions/CarAction";
import { useParams } from "react-router-dom";

const Detailsproduct = ({userData}) => {
    const idproduct=useParams()
    const dispatch = useDispatch();
    const dataa = useSelector((state) => state.CarReduser.GetcarbyId);
    useEffect(()=>{
  dispatch(getCarByIdAction(idproduct.id))
    },[idproduct.id])
  return (
    <div>
      <Row className="py-3">
        <Col lg="4">
          <ProductGallery
          dataa={dataa}
          />
        </Col>

        <Col lg="8">
          <ProductText userData={userData} dataa={dataa} idproduct={idproduct}/>
        </Col>
      </Row>
    </div>
  );
};

export default Detailsproduct;
